import { render } from "./pairing-ad.vue?vue&type=template&id=2ef7f2ea&scoped=true&lang=pug"
import script from "./pairing-ad.vue?vue&type=script&lang=js"
export * from "./pairing-ad.vue?vue&type=script&lang=js"

import "./pairing-ad.vue?vue&type=style&index=0&id=2ef7f2ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef7f2ea"]])

export default __exports__